import { Entity } from '@/store/shared/entity'
import FactoryEntity from './factoryentity'
export default class FactoryCost extends Entity<number>{
    factoryConfirmStatus:string;
    shippingNumber:string;
    shipmentDate:Date;
    customerName:string;
    allTotal:number;
    owner:string;
    recordDto:Array<FactoryEntity>=new Array<FactoryEntity>();
}